import { Fragment, useRef, useState } from "react";
import { Button, Card, TabContent, TabPane } from "reactstrap";
import TreeView from "../../treeView";
import ProgramForm from "../programForm";
import { useSelector } from "react-redux";
import MemberBenefits from "../../../MemberBenefits/Member-Benefits";
import MemberBenefitsCopy from "../../../MemberBenefits/Member-Benefits copy"
import ProgramMapping from "./ProgramMapping";

const TabComponent = ({ activeTab }) => {
  const serviceForm = useRef();
  const [reload, setReload] = useState(false);
  const program = useSelector((state) => state.programs.programDetail);

  const submitForm = async () => {
    try {
      await serviceForm.current.handleSubmit();
      setReload(!reload);
    } catch (err) {}
  };

  return (
    <Fragment>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          {activeTab === "1" && <TreeView reload={reload} type={"Programs"} />}
        </TabPane>
        <TabPane tabId="2">
          <Card className="p-4">
            <ProgramMapping reloadData={reload}/>
          </Card>
        </TabPane>
        <TabPane tabId="3">
          <Card className="p-4">
            <ProgramForm ref={serviceForm} formType="edit"></ProgramForm>
          </Card>
        </TabPane>
        <TabPane tabId="4">
          <Card className="p-4">
            {activeTab === "4" && <MemberBenefits program={program} />}
          </Card>
        </TabPane>
         <TabPane tabId="5">
          <Card className="p-4">
            {activeTab === "5" && <MemberBenefitsCopy program={program} reload={reload}/>}
          </Card>
        </TabPane>
      </TabContent>
    </Fragment>
  );
};

export default TabComponent;
